import { render } from "./ValidationFormContainer.vue?vue&type=template&id=f596cf44"
import script from "./ValidationFormContainer.vue?vue&type=script&lang=js"
export * from "./ValidationFormContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__